// components/GraphPlotter/segments/generateSegmentTraces.js

const DEFAULT_FUNCTION_COLOR = "#ff9800";

export default function generateSegmentTraces(segments, points) {
  const traces = [];

  for (const {
    p1,
    p2,
    color,
    markerColor,
    width,
    showMarkers = true,
  } of segments) {
    const pt1 = points[p1];
    const pt2 = points[p2];
    if (!pt1 || !pt2) continue;

    traces.push({
      type: "scatter",
      mode: showMarkers ? "lines+markers" : "lines",
      x: [pt1.x, pt2.x],
      y: [pt1.y, pt2.y],
      line: { color: color || DEFAULT_FUNCTION_COLOR, width: width || 6 },
      ...(showMarkers
        ? { marker: { color: markerColor || color || DEFAULT_FUNCTION_COLOR } }
        : {}),
      name: `${p1}${p2}`,
      hoverinfo: "name+x+y",
      showlegend: false,
    });
  }

  return traces;
}
